import { FaReact } from "react-icons/fa";

export default function HomePage () {
    return (
        <div className="home-page">

            <FaReact className="react-icon"/>

            <div className="logo">
                <h1>Andrew Torres</h1>
                <span>Software Developer</span>
            </div>
            
        </div>
    )
}